import { jsx as _jsx } from "react/jsx-runtime";
import { useHead } from "@/hooks";
import { HeadInfosShell } from "@seo/head-infos";
import { useClassifiedId, useHeadInfo } from "@/contexts/classified";
export const Head = () => {
    // Load external scripts and styles
    useHead();
    const metas = [
        {
            // Prevent iOS from detecting telephone numbers
            name: "format-detection",
            content: "telephone=no",
        },
    ];
    const headInfosProps = {
        title: useClassifiedId(),
        description: "",
        metas,
        ...useHeadInfo(),
    };
    return _jsx(HeadInfosShell, { ...headInfosProps });
};
